export enum ButtonType {
  link = 'link',
  action = 'action',
  submit = 'submit',
}
